import {
  Box,
  Flex,
  ListItem,
  ModalBody,
  ModalFooter,
  ModalHeader,
  OrderedList,
} from '@chakra-ui/react'

import { Box as DarkBox, tokenPrefix, tokenVar } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { Button } from '@/components/ui'

import { GridModalHeader } from '../../components/GridModalHeader'

interface InstructionsStepIProps {
  colorScheme?: ColorScheme
  onBegin: () => void
  onClose: () => void
}

export const InstructionsStep = ({
  colorScheme,
  onBegin,
  onClose,
}: InstructionsStepIProps) => {
  if (colorScheme) {
    return (
      <DarkBox
        as='ol'
        color={tokenVar(`colors.${tokenPrefix(colorScheme)}text.secondary`)}
        display='flex'
        flexDirection='column'
        fontSize='14px'
        gap='8px'
        listStyleType='decimal'
        pl='20px'
      >
        <DarkBox as='li'>Review and adjust the camera grids.</DarkBox>
        <DarkBox as='li'>
          Select a past incident and enter expected IN/OUT counts.
        </DarkBox>
        <DarkBox as='li'>
          Await results while the video is processed by the Ingress Detector.
        </DarkBox>
        <DarkBox as='li'>View the detection accuracy results.</DarkBox>
        <DarkBox as='li'>
          Save your new grid configuration or return to Step 2 in order to
          continue testing.
        </DarkBox>
      </DarkBox>
    )
  }

  const content = (
    <Box>
      <OrderedList color='gray.700' fontSize='sm' spacing={2}>
        <ListItem>Review and adjust the camera grids.</ListItem>
        <ListItem>
          Select a past incident and enter expected IN/OUT counts.
        </ListItem>
        <ListItem>
          Await results while the video is processed by the Ingress Detector.
        </ListItem>
        <ListItem>View the detection accuracy results.</ListItem>
        <ListItem>
          Save your new grid configuration or return to Step 2 in order to
          continue testing.
        </ListItem>
      </OrderedList>
    </Box>
  )

  return (
    <>
      <ModalHeader p={0} w='100%'>
        <GridModalHeader subtitle='' title='Grid Testing Zone' />
      </ModalHeader>
      <ModalBody p={0}>{content}</ModalBody>
      <ModalFooter mt={6} p={0}>
        <Flex direction='row' gap={3} justifyContent='flex-end'>
          <Button mr={0} onClick={onClose} variant='secondary'>
            Cancel
          </Button>
          <Button onClick={onBegin}>Enter</Button>
        </Flex>
      </ModalFooter>
    </>
  )
}
